import { isIos } from 'utils/platform';

export function resetScroll({ element }: { element: HTMLElement }): void {
  if (isIos()) {
    element.style.overflowY = 'hidden';
    element.scrollTo({ top: 0 });
    element.style.overflowY = 'scroll';
  } else {
    element.scrollTo({ top: 0 });
  }
}
